(() => {
  const menuButton = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("[data-menu]");
  if (menuButton && menu) {
    menuButton.addEventListener("click", () => {
      const isOpen = document.body.classList.toggle("menu-open");
      menuButton.setAttribute("aria-expanded", String(isOpen));
    });
    menu.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => {
      document.body.classList.remove("menu-open");
      menuButton.setAttribute("aria-expanded", "false");
    }));
  }

  document.querySelectorAll("[data-accordion-button]").forEach((button) => {
    button.addEventListener("click", () => {
      const panel = document.getElementById(button.getAttribute("aria-controls"));
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  document.querySelectorAll("[data-gallery-button]").forEach((button) => {
    button.addEventListener("click", () => {
      const gallery = button.closest("[data-gallery]");
      const image = gallery?.querySelector("[data-gallery-image]");
      if (!gallery || !image) return;
      image.classList.add("is-changing");
      window.setTimeout(() => {
        image.src = button.dataset.src;
        image.srcset = "";
        image.alt = button.dataset.alt || "Fotografía FURTYVO";
        image.classList.remove("is-changing");
      }, 140);
      gallery.querySelectorAll("[data-gallery-button]").forEach((item) => {
        item.setAttribute("aria-pressed", String(item === button));
      });
    });
  });

  const productSection = document.querySelector("[data-product-section]");
  if (productSection) {
    const variantSelect = productSection.querySelector("[data-product-variant-select]");
    const priceNode = productSection.querySelector("[data-product-price]");
    const compareNode = productSection.querySelector("[data-product-compare]");
    const availabilityNode = productSection.querySelector("[data-product-availability]");
    const submitButtons = document.querySelectorAll("[data-product-submit]");
    const mediaFrames = [...productSection.querySelectorAll("[data-product-media-id]")];
    const mediaButtons = [...productSection.querySelectorAll("[data-product-media-button]")];
    const locale = productSection.dataset.locale || "es-ES";
    const currency = productSection.dataset.currency || "EUR";

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(locale, { style: "currency", currency }).format(Number(cents) / 100);
      } catch {
        return `${(Number(cents) / 100).toFixed(2)} ${currency}`;
      }
    };

    const showMedia = (id) => {
      const chosen = mediaFrames.find((frame) => frame.dataset.productMediaId === String(id));
      if (!chosen) return;
      mediaFrames.forEach((frame) => {
        frame.hidden = frame !== chosen;
        if (frame !== chosen) frame.querySelectorAll("video").forEach((video) => video.pause());
      });
      mediaButtons.forEach((button) => {
        button.setAttribute("aria-pressed", String(button.dataset.productMediaButton === String(id)));
      });
    };

    mediaButtons.forEach((button) => button.addEventListener("click", () => showMedia(button.dataset.productMediaButton)));

    if (variantSelect) {
      variantSelect.addEventListener("change", () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === "true";
        const price = Number(option.dataset.price);
        const comparePrice = Number(option.dataset.comparePrice);
        if (priceNode) priceNode.textContent = money(price);
        if (compareNode) {
          compareNode.hidden = !(comparePrice > price);
          compareNode.textContent = comparePrice > price ? money(comparePrice) : "";
        }
        if (availabilityNode) availabilityNode.textContent = available ? "Disponible" : "Agotado";
        submitButtons.forEach((button) => { button.disabled = !available; });
        if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
        const url = new URL(window.location.href);
        url.searchParams.set("variant", option.value);
        window.history.replaceState({}, "", url);
      });
    }
  }

  const revealItems = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add("is-visible"));
  }
})();
